import React, { useState, useEffect } from 'react';
import api from '../api';
import '../styles/Home.css';

const Home = () => {
    const [projects, setProjects] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [loading, setLoading] = useState(true);

    const categories = [
        'All', 'Technology', 'Art', 'Music', 'Gaming',
        'Social Impact', 'Business', 'Literature', 'Content Creation'
    ];

    useEffect(() => {
        const fetchHomeProjects = async () => {
            setLoading(true);
            try {
                const token = sessionStorage.getItem('token');
                const res = await api.get(`/api/home/projects`, {
                    params: { category: selectedCategory },
                    headers: { Authorization: `Bearer ${token}` }
                });
                setProjects(res.data);
                setLoading(false);
            } catch (err) {
                console.error("Fetch Error:", err);
                setLoading(false);
            }
        };
        fetchHomeProjects();
    }, [selectedCategory]);

    const handleJoinProject = async (projectId) => {
        try {
            const token = sessionStorage.getItem('token');
            await api.post(`/api/home/join/${projectId}`, {}, {
                headers: { Authorization: `Bearer ${token}` }
            });
            // Remove from UI immediately after joining
            setProjects(prev => prev.filter(p => p.id !== projectId));
        } catch (err) {
            alert(err.response?.data?.message || "Error joining project.");
        }
    };

    return (
        <div className="home-container">
            <div className="category-menu-container">
                <div className="category-menu">
                    {categories.map(cat => (
                        <button
                            key={cat}
                            className={`category-item ${selectedCategory === cat ? 'active' : ''}`}
                            onClick={() => setSelectedCategory(cat)}
                        >
                            {cat}
                        </button>
                    ))}
                </div>
            </div>

            <div className="home-content">
                {loading ? (
                    <div className="status-msg">Finding projects...</div>
                ) : (
                    <div className="discovery-grid">
                        {projects.map(proj => (
                            <div key={proj.id} className="project-card"> {/* Matches My Projects class */}
                                <div className="card-image">
                                    {proj.image_url ? (
                                        <img src={`${proj.image_url}`} alt={proj.name} />
                                    ) : (
                                        <div className="placeholder-image-box"></div>
                                    )}
                                </div>

                                <div className="card-info">
                                    <span className="category-tag">{proj.category}</span>
                                    <h3>{proj.name}</h3>
                                    <p>{proj.description}</p>

                                    <button
                                        className="view-btn"
                                        onClick={() => handleJoinProject(proj.id)}
                                    >
                                        Join Project
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Home;